<template>
  <div class="wedding-catering">
    <!-- 头部 -->
    <v-header></v-header>
    <!-- 广告 -->
    <div class="banner">
      <img
        src="../assets/images/wedding_banner_bg.png"
        :alt="this.$t('message.wedtag')"
      />
      <div class="bg"></div>
      <div class="center">
        <h1>{{ $t("message.wedding.banner.h") }}</h1>
        <h3>{{ $t("message.wedding.banner.p") }}</h3>
        <menubtn></menubtn>
      </div>
    </div>
    <!-- 内容 -->
    <div class="party-c">
      <!-- SEO -->
      <div class="center">
        <div class="seo">
          <h2>
            <img
              src="../assets/images/pc_hz_title_line1.png"
              style="padding: 0 0 6px 0"
              alt
            />
            {{ $t("message.wedding.content.h") }}
            <img
              src="../assets/images/pc_hz_title_line2.png"
              alt
              style="padding: 0 0 6px 0"
            />
          </h2>
          <div class="seo-show">
            <div>
              <div>
                <img src="../assets/images/daohui_wedding_img1.png" alt />
              </div>
              <div>
                <h2>{{ $t("message.wedding.content.ctitle1") }}</h2>
                <p
                  title="每個婚禮都總會有一個關於食的環節，這是一個眾所周知的事實。時至今日，婚禮到會已經演變成接待賓客好重要的一環。一場溫馨及甜蜜的戶外婚宴，除了決定婚禮主題及戶外婚禮場地佈置，招待親友的到會美食及小食甜品同樣是婚宴重點！新人都會花盡心血物色平靚正婚禮到會，務求食物得體精緻又好食，與主題相呼應，也突顯你的獨有品味。精緻的婚禮到會，一定會令你的婚宴大大加分！"
                >
                  {{ $t("message.wedding.content.span1") }}
                </p>
              </div>
            </div>
            <div>
              <div>
                <img src="../assets/images/daohui_wedding_img2.png" alt />
              </div>
              <div>
                <h2>{{ $t("message.wedding.content.ctitle2") }}</h2>
                <p
                  title="到會家為婚禮到會設計了一系列的餐單，這些餐單是經過以往的婚禮到會經驗而精心設計的，可為新人們推介婚禮必備的美食。另外，到會家更可以根據您的心中的要求，為您度身訂製婚禮到會餐單。或者如果您有自定義的食物，我們都可以為您特意烹飪，只要您想得出的美食，我們都會為您製造得更好更美味。"
                >
                  {{ $t("message.wedding.content.span2") }}
                </p>
                <br />
                <br />
                <p
                  title="超過三十年經驗的廚師為您製作婚宴美食，值得信賴。除了精緻的婚禮到會美食，我們也提供自助餐保溫熱爐、酒水香檳、侍應服務等服務。我們過往為無數客人提供華麗體面的婚禮到會服務，務求為您的人生里程碑與一個難忘的盛宴結合起來。"
                >
                  {{ $t("message.wedding.content.span3") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 尾部 -->
    <div class="activity-contanier">
      <div class="activity-main">
        <Title :title="$t('message.wedding.context.h2TitleOne')"></Title>
        <Content :content="$t('message.wedding.context.pContentOneFirst')"></Content>
        <Content :content="$t('message.wedding.context.pContentOneSecond')"></Content>
        <Content :content="$t('message.wedding.context.pContentOneThird')"></Content>
      </div>
    </div>
    <div class="faq-contanier">
      <div class="faq-main">
        <Title :title="$t('message.wedding.aboutWeddingTitle')"></Title>
        <div class="feq-content">
          <div class="about-food-main">
            <div v-for="item in 3" :key="item" style="margin-left:10px">
              <h3 style="color: #000">{{ $t(`message.wedding.aboutWedding.faq${item}`) }}</h3>
              <div style="margin-left:10px" class="feq-content-text">
                {{ $t(`message.wedding.aboutWedding.content${item}`) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import header from "../components/header";
import menubtn from "../components/menubtn";
import Title from './common/title.vue'
import Content from './common/content.vue'
export default {
  name: "caterers",
  data() {
    return {};
  },
  components: {
    "v-header": header,
    menubtn,
    Title,
    Content
  }
};
</script>
<style lang="less" scoped>
.activity-contanier {
  background-image: url("../assets/images/bodybg.jpg");
  background-size: 100% 100%;

  .activity-main {
    width: 70%;
    padding: 3% 2%;
    margin: 0 auto;
    @media (max-width: 1255px) {
      width: 90%;
    }

    .activity-content-main {
      display: flex;
      justify-content: space-around;
      @media (max-width: 768px) {
        flex-wrap: wrap;
        justify-content: space-between;
      }

      .activity-item ~ .activity-item {
        margin-left: 30px;
        @media (max-width: 768px) {
          margin-left: 0px;
        }
      }

      .activity-item {
        text-align: center;
        flex: 0 0 30%;
        @media (max-width: 768px) {
          flex: 0 0 48%;
        }
        @media (max-width: 480px) {
          flex: 0 0 100%;
          display: flex;
          margin-bottom: 3%;
          text-align: left;
        }

        .activity-item-img {
          .item-img {
            width: 100%;
            height: 100%;
          }

          @media (max-width: 480px) {
            flex: 0 0 48%;
          }
        }

        .activity-item-content, .activity-item-span {
          margin: 20px;
        }

        .activity-item-content {
          font-size: 1.2vw;
          font-weight: 550;
        }

        .activity-item-span {
          font-size: 13px;
          color: #919599;
          font-weight: 350;
        }

        .item-button {
          @media (max-width: 480px) {
            margin: 0 20px;
          }
        }
      }
    }
  }
}
.faq-contanier {
  .faq-main {
    width: 70%;
    margin: 0 auto;
    @media (max-width: 1255px) {
      width: 90%;
    }

    .feq-content {
      margin: 0 0 3%;
      font-size: .825rem;
      color: #919599;

      .feq-content-text {
        margin-bottom: 3%;
      }
    }

  }
}
.wedding-catering .center {
  width: 75%;
  margin: auto;
}
/* 广告 */
.wedding-catering .banner {
  position: relative;
  width: 100%;
  margin: 110px 0 0 0;
}
.wedding-catering .banner img {
  width: 100%;
  height: 100%;
}
.wedding-catering .banner h1,
.wedding-catering .banner h3 {
  margin: 0 5px 5px 5px;
  text-align: center;
  color: white;
}
.wedding-catering .banner h1 {
  font-weight: 500;
  font-size: 4vw;
}
.wedding-catering .banner h3 {
  font-weight: 500;
  font-size: 2vw;
}
.wedding-catering .banner p {
  margin: 1% 0;
  font-size: 15px;
}
.wedding-catering .banner .center {
  width: 80%;
  height: 40%;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 3;
  margin: auto;
}
.wedding-catering .banner .banner-call1 {
  font-weight: 200;
  color: #eb6410;
  letter-spacing: 0;
  margin: 0 0 3% 0;
  font-size: 1.1rem;
}
.wedding-catering .seo {
  margin: 8% 0;
  overflow: hidden;
}
.wedding-catering .seo-show {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
}
.wedding-catering .seo-show > div {
  flex: 0 0 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 3%;
}
.wedding-catering .seo-show > div img {
  width: 100%;
}
.wedding-catering .seo-show > div > div:nth-child(1) {
  flex: 0 0 100%;
  margin-bottom: 20px;
}
.wedding-catering .seo-show > div > div:nth-child(2) {
  flex: 0 0 100%;
}
.wedding-catering .seo-show > div > div:nth-child(2) img {
  width: 100%;
}
.wedding-catering .seo-show > div > div:nth-child(2) h2 {
  font-weight: 600;
  margin-bottom: 20px;
  border-left: 3px solid;
  padding: 0 2%;
  text-align: left;
}
.wedding-catering .seo-show > div > div:nth-child(2) p {
  font-size: 15px;
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  /* -webkit-line-clamp: 4; */
}
.wedding-catering .seo h2 {
  text-align: center;
  font-size: 1.4vw;
  font-weight: 400;
  margin: 5% 0 8% 0;
}
.wedding-catering .seo h1 img {
  width: 250px;
}
.wedding-catering .seo > p {
  float: right;
  margin: 2% auto;
  font-size: 14px;
  width: 70%;
  text-indent: 2rem;
}
@media (max-width: 1450px) {
  .wedding-catering .seo h2 {
    font-size: 2vw;
  }
}
@media (max-width: 1040px) {
  .wedding-catering .seo h2 img {
    width: 20%;
  }
}
@media screen and (min-width: 769px) and (max-width: 1024px) {
  .wedding-catering .banner h1 {
    font-size: 4vw;
  }
  .wedding-catering .banner h3 {
    font-size: 3vw;
  }
  .wedding-catering .center {
    width: 90%;
  }
  .wedding-catering .seo h2 {
    font-size: 2.8vw;
  }
}
@media screen and (min-width: 480px) and (max-width: 768px) {
  .wedding-catering .banner h1 {
    font-size: 5vw;
  }
  .wedding-catering .banner h3 {
    font-size: 3vw;
  }
  .wedding-catering .center {
    width: 90%;
  }
  .wedding-catering .seo h2 {
    font-size: 2.8vw;
  }
}
@media (max-width: 480px) {
  .wedding-catering .banner {
    margin-top: 135px;
    height: 180px;
  }
  .wedding-catering .seo h2 {
    font-size: 4.5vw;
  }
  .wedding-catering .seo h2 img {
    padding: 0 0 6px 0;
    width: 20%;
  }
  .wedding-catering .banner .center {
    width: 100%;
    height: 70%;
  }
  .wedding-catering .banner h1 {
    font-size: 6.5vw;
    font-weight: 500;
  }
  .wedding-catering .banner h3 {
    font-size: 4vw;
    font-weight: 500;
  }
  /* seo */
  .wedding-catering .seo h1 {
    font-size: 1.4rem;
    margin: 3% 0;
  }
  .wedding-catering .seo > p {
    width: 100%;
    font-weight: 400;
    padding: 0 3%;
    box-sizing: border-box;
  }
  .wedding-catering .center {
    width: 100%;
  }
  .wedding-catering .seo-show > div {
    margin-bottom: 6%;
  }
  .wedding-catering .seo h1 img {
    width: 30%;
  }
  .wedding-catering .seo-show > div > div:nth-child(1) {
    flex: 0 0 100%;
    text-align: center;
    margin: 0 0 5% 0;
  }
  .wedding-catering .seo-show > div > div:nth-child(2) {
    flex: 0 0 100%;
    padding: 0 5%;
    box-sizing: border-box;
  }
  .wedding-catering .seo-show > div > div:nth-child(2) h2 {
    font-size: 20px;
    font-weight: 400;
  }
  .wedding-catering .seo-show > div img {
    width: 95%;
  }
}
</style>
<style>
.wedding-catering .banner .el-button.el-button--success {
  display: block;
  width: 100%;
  margin: 0;
  background: #eb6410;
  border: 1px solid #eb6410;
  /* padding: 0; */
  /* font-size: 18px; */
}
.wedding-catering .banner .el-button.el-button--success a,
.wedding-catering .banner .el-button.el-button--success span {
  display: block;
  height: 100%;
}
.wedding-catering .banner .el-dialog {
  margin-top: 12vh !important;
}
.wedding-catering .banner .el-dialog__body {
  padding: 0 33px 0 0 !important;
}
.wedding-catering .el-scrollbar__view.el-time-spinner__list li,
.el-scrollbar__view.el-select-dropdown__list li {
  display: block;
}
</style>
